<template>
  <Sheet>
    <template #leading>
      <Sheet.Button
        :icon="isMatch ? CloseIcon : ChevronLeftIcon"
        :disabled="flagged.creating.value"
        @click="isMatch ? close() : flagged.back()"
      />
    </template>
    <template #title>{{ title }}</template>

    <Sheet.Body
      class="pb-[calc(env(safe-area-inset-bottom)+16px)]!"
      :class="flagged.step.value === 'details' ? 'pt-[15px]' : 'pt-[25px]'"
    >
      <FlaggedMatchBody variant="sheet" :flagged="flagged" />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Sheet, useSheet } from '@dacr/library'
import { ChevronLeftIcon, CloseIcon } from '@dacr/icons'

import FlaggedMatchBody from './FlaggedMatchBody.vue'
import { useFlaggedMatch, type FlaggedInfringement } from './useFlaggedMatch'

const props = defineProps<{ infringement: FlaggedInfringement }>()

const { close } = useSheet()
const flagged = useFlaggedMatch(props.infringement)

const isMatch = computed(() => flagged.step.value === 'match')
const title = computed(() =>
  flagged.step.value === 'confirm' ? 'Create report' : flagged.title.value
)
</script>
